/**
 * COURE.HUB.DS.TransactionLog.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { HubBillingTransactionDto } from '../model/hubBillingTransactionDto';
import { HubBillingTransactionDtoPaginatedResponse } from '../model/hubBillingTransactionDtoPaginatedResponse';
import { ProblemDetails } from '../model/problemDetails';
import { TransactionLogDto } from '../model/transactionLogDto';
import { TransactionLogModel } from '../model/transactionLogModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TransactionLogsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param transactionId 
     * @param destinationNumber 
     * @param originationNumber 
     * @param senderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTransactionLogsDetailGet(id?: string, transactionId?: string, destinationNumber?: string, originationNumber?: string, senderId?: string, observe?: 'body', reportProgress?: boolean): Observable<TransactionLogModel>;
    public apiTransactionLogsDetailGet(id?: string, transactionId?: string, destinationNumber?: string, originationNumber?: string, senderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionLogModel>>;
    public apiTransactionLogsDetailGet(id?: string, transactionId?: string, destinationNumber?: string, originationNumber?: string, senderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionLogModel>>;
    public apiTransactionLogsDetailGet(id?: string, transactionId?: string, destinationNumber?: string, originationNumber?: string, senderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (transactionId !== undefined && transactionId !== null) {
            queryParameters = queryParameters.set('transactionId', <any>transactionId);
        }
        if (destinationNumber !== undefined && destinationNumber !== null) {
            queryParameters = queryParameters.set('destinationNumber', <any>destinationNumber);
        }
        if (originationNumber !== undefined && originationNumber !== null) {
            queryParameters = queryParameters.set('originationNumber', <any>originationNumber);
        }
        if (senderId !== undefined && senderId !== null) {
            queryParameters = queryParameters.set('senderId', <any>senderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TransactionLogModel>('get',`${this.basePath}/api/TransactionLogs/detail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param transactionId 
     * @param destinationNumber 
     * @param originationNumber 
     * @param senderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTransactionLogsDetailsGet(id?: string, transactionId?: string, destinationNumber?: string, originationNumber?: string, senderId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TransactionLogModel>>;
    public apiTransactionLogsDetailsGet(id?: string, transactionId?: string, destinationNumber?: string, originationNumber?: string, senderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TransactionLogModel>>>;
    public apiTransactionLogsDetailsGet(id?: string, transactionId?: string, destinationNumber?: string, originationNumber?: string, senderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TransactionLogModel>>>;
    public apiTransactionLogsDetailsGet(id?: string, transactionId?: string, destinationNumber?: string, originationNumber?: string, senderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (transactionId !== undefined && transactionId !== null) {
            queryParameters = queryParameters.set('transactionId', <any>transactionId);
        }
        if (destinationNumber !== undefined && destinationNumber !== null) {
            queryParameters = queryParameters.set('destinationNumber', <any>destinationNumber);
        }
        if (originationNumber !== undefined && originationNumber !== null) {
            queryParameters = queryParameters.set('originationNumber', <any>originationNumber);
        }
        if (senderId !== undefined && senderId !== null) {
            queryParameters = queryParameters.set('senderId', <any>senderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<TransactionLogModel>>('get',`${this.basePath}/api/TransactionLogs/details`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param search 
     * @param transactionRef 
     * @param routeName 
     * @param from 
     * @param to 
     * @param destinationNumber 
     * @param originationNumber 
     * @param senderId 
     * @param page 
     * @param pageSize 
     * @param draw 
     * @param messageStatus 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTransactionLogsGetalltransactionServiceProviderGet(serviceProviderId: string, search?: string, transactionRef?: string, routeName?: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, page?: number, pageSize?: number, draw?: number, messageStatus?: number, observe?: 'body', reportProgress?: boolean): Observable<HubBillingTransactionDtoPaginatedResponse>;
    public apiTransactionLogsGetalltransactionServiceProviderGet(serviceProviderId: string, search?: string, transactionRef?: string, routeName?: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, page?: number, pageSize?: number, draw?: number, messageStatus?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<HubBillingTransactionDtoPaginatedResponse>>;
    public apiTransactionLogsGetalltransactionServiceProviderGet(serviceProviderId: string, search?: string, transactionRef?: string, routeName?: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, page?: number, pageSize?: number, draw?: number, messageStatus?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<HubBillingTransactionDtoPaginatedResponse>>;
    public apiTransactionLogsGetalltransactionServiceProviderGet(serviceProviderId: string, search?: string, transactionRef?: string, routeName?: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, page?: number, pageSize?: number, draw?: number, messageStatus?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceProviderId === null || serviceProviderId === undefined) {
            throw new Error('Required parameter serviceProviderId was null or undefined when calling apiTransactionLogsGetalltransactionServiceProviderGet.');
        }













        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (transactionRef !== undefined && transactionRef !== null) {
            queryParameters = queryParameters.set('transactionRef', <any>transactionRef);
        }
        if (routeName !== undefined && routeName !== null) {
            queryParameters = queryParameters.set('routeName', <any>routeName);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from.toISOString());
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to.toISOString());
        }
        if (destinationNumber !== undefined && destinationNumber !== null) {
            queryParameters = queryParameters.set('destinationNumber', <any>destinationNumber);
        }
        if (originationNumber !== undefined && originationNumber !== null) {
            queryParameters = queryParameters.set('originationNumber', <any>originationNumber);
        }
        if (senderId !== undefined && senderId !== null) {
            queryParameters = queryParameters.set('senderId', <any>senderId);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('pageSize', <any>pageSize);
        }
        if (draw !== undefined && draw !== null) {
            queryParameters = queryParameters.set('draw', <any>draw);
        }
        if (messageStatus !== undefined && messageStatus !== null) {
            queryParameters = queryParameters.set('messageStatus', <any>messageStatus);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<HubBillingTransactionDtoPaginatedResponse>('get',`${this.basePath}/api/TransactionLogs/getalltransactionServiceProvider`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTransactionLogsPost(body?: TransactionLogDto, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiTransactionLogsPost(body?: TransactionLogDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiTransactionLogsPost(body?: TransactionLogDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiTransactionLogsPost(body?: TransactionLogDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/TransactionLogs`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param aggregatorId 
     * @param serviceProviderId 
     * @param from 
     * @param to 
     * @param destinationNumber 
     * @param originationNumber 
     * @param senderId 
     * @param startFrom 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTransactionLogsTransactionAggregatorGet(aggregatorId: string, serviceProviderId?: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, startFrom?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<HubBillingTransactionDto>>;
    public apiTransactionLogsTransactionAggregatorGet(aggregatorId: string, serviceProviderId?: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, startFrom?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HubBillingTransactionDto>>>;
    public apiTransactionLogsTransactionAggregatorGet(aggregatorId: string, serviceProviderId?: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, startFrom?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HubBillingTransactionDto>>>;
    public apiTransactionLogsTransactionAggregatorGet(aggregatorId: string, serviceProviderId?: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, startFrom?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (aggregatorId === null || aggregatorId === undefined) {
            throw new Error('Required parameter aggregatorId was null or undefined when calling apiTransactionLogsTransactionAggregatorGet.');
        }









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (aggregatorId !== undefined && aggregatorId !== null) {
            queryParameters = queryParameters.set('aggregatorId', <any>aggregatorId);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from.toISOString());
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to.toISOString());
        }
        if (destinationNumber !== undefined && destinationNumber !== null) {
            queryParameters = queryParameters.set('destinationNumber', <any>destinationNumber);
        }
        if (originationNumber !== undefined && originationNumber !== null) {
            queryParameters = queryParameters.set('originationNumber', <any>originationNumber);
        }
        if (senderId !== undefined && senderId !== null) {
            queryParameters = queryParameters.set('senderId', <any>senderId);
        }
        if (startFrom !== undefined && startFrom !== null) {
            queryParameters = queryParameters.set('startFrom', <any>startFrom);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<HubBillingTransactionDto>>('get',`${this.basePath}/api/TransactionLogs/transactionAggregator`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param messageId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTransactionLogsTransactionMessageIdGet(messageId: string, observe?: 'body', reportProgress?: boolean): Observable<TransactionLogModel>;
    public apiTransactionLogsTransactionMessageIdGet(messageId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionLogModel>>;
    public apiTransactionLogsTransactionMessageIdGet(messageId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionLogModel>>;
    public apiTransactionLogsTransactionMessageIdGet(messageId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (messageId === null || messageId === undefined) {
            throw new Error('Required parameter messageId was null or undefined when calling apiTransactionLogsTransactionMessageIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TransactionLogModel>('get',`${this.basePath}/api/TransactionLogs/transaction/${encodeURIComponent(String(messageId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param from 
     * @param to 
     * @param destinationNumber 
     * @param originationNumber 
     * @param senderId 
     * @param startFrom 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTransactionLogsTransactionServiceProviderGet(serviceProviderId: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, startFrom?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<HubBillingTransactionDto>>;
    public apiTransactionLogsTransactionServiceProviderGet(serviceProviderId: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, startFrom?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HubBillingTransactionDto>>>;
    public apiTransactionLogsTransactionServiceProviderGet(serviceProviderId: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, startFrom?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HubBillingTransactionDto>>>;
    public apiTransactionLogsTransactionServiceProviderGet(serviceProviderId: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, startFrom?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceProviderId === null || serviceProviderId === undefined) {
            throw new Error('Required parameter serviceProviderId was null or undefined when calling apiTransactionLogsTransactionServiceProviderGet.');
        }








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from.toISOString());
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to.toISOString());
        }
        if (destinationNumber !== undefined && destinationNumber !== null) {
            queryParameters = queryParameters.set('destinationNumber', <any>destinationNumber);
        }
        if (originationNumber !== undefined && originationNumber !== null) {
            queryParameters = queryParameters.set('originationNumber', <any>originationNumber);
        }
        if (senderId !== undefined && senderId !== null) {
            queryParameters = queryParameters.set('senderId', <any>senderId);
        }
        if (startFrom !== undefined && startFrom !== null) {
            queryParameters = queryParameters.set('startFrom', <any>startFrom);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<HubBillingTransactionDto>>('get',`${this.basePath}/api/TransactionLogs/transactionServiceProvider`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param aggregatorId 
     * @param serviceProviderId 
     * @param from 
     * @param to 
     * @param destinationNumber 
     * @param originationNumber 
     * @param senderId 
     * @param startFrom 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTransactionLogsTransactionSuperAdminGet(aggregatorId?: string, serviceProviderId?: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, startFrom?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<HubBillingTransactionDto>>;
    public apiTransactionLogsTransactionSuperAdminGet(aggregatorId?: string, serviceProviderId?: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, startFrom?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HubBillingTransactionDto>>>;
    public apiTransactionLogsTransactionSuperAdminGet(aggregatorId?: string, serviceProviderId?: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, startFrom?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HubBillingTransactionDto>>>;
    public apiTransactionLogsTransactionSuperAdminGet(aggregatorId?: string, serviceProviderId?: string, from?: Date, to?: Date, destinationNumber?: string, originationNumber?: string, senderId?: string, startFrom?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (aggregatorId !== undefined && aggregatorId !== null) {
            queryParameters = queryParameters.set('aggregatorId', <any>aggregatorId);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from.toISOString());
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to.toISOString());
        }
        if (destinationNumber !== undefined && destinationNumber !== null) {
            queryParameters = queryParameters.set('destinationNumber', <any>destinationNumber);
        }
        if (originationNumber !== undefined && originationNumber !== null) {
            queryParameters = queryParameters.set('originationNumber', <any>originationNumber);
        }
        if (senderId !== undefined && senderId !== null) {
            queryParameters = queryParameters.set('senderId', <any>senderId);
        }
        if (startFrom !== undefined && startFrom !== null) {
            queryParameters = queryParameters.set('startFrom', <any>startFrom);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<HubBillingTransactionDto>>('get',`${this.basePath}/api/TransactionLogs/transactionSuperAdmin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param receiptId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTransactionLogsTransactionlogReceiptIdGet(receiptId: string, observe?: 'body', reportProgress?: boolean): Observable<HubBillingTransactionDto>;
    public apiTransactionLogsTransactionlogReceiptIdGet(receiptId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<HubBillingTransactionDto>>;
    public apiTransactionLogsTransactionlogReceiptIdGet(receiptId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<HubBillingTransactionDto>>;
    public apiTransactionLogsTransactionlogReceiptIdGet(receiptId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (receiptId === null || receiptId === undefined) {
            throw new Error('Required parameter receiptId was null or undefined when calling apiTransactionLogsTransactionlogReceiptIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<HubBillingTransactionDto>('get',`${this.basePath}/api/TransactionLogs/transactionlog/${encodeURIComponent(String(receiptId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
